import React, { useState } from 'react';
import TourOperatorManagement from './TourOperatorManagement';
import HotelLibrary from './HotelLibrary';

const MasterDataManagement = () => {
  const [activeTab, setActiveTab] = useState('hotels');

  const tabs = [
    { id: 'operators', name: 'Tour Operators', icon: '🏢' },
    { id: 'hotels', name: 'Hotels Library', icon: '🏨' }
  ];

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Master Data Management</h1>
        <p className="text-gray-600">Manage tour operators and hotels library</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 ${
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <span className="text-xl">{tab.icon}</span>
              <span>{tab.name}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <div>
        {activeTab === 'operators' && <TourOperatorManagement />}
        {activeTab === 'hotels' && <HotelLibrary />}
      </div>
    </div>
  );
};

export default MasterDataManagement;
